import React from 'react'
import Typography from '@material-ui/core/Typography'

export type overviewSectionTitlePropsType = {
  titleName: string
//  variant?: 'h3' | 'h4' | 'h5' | 'h6'
  styles?: string
}

export const OverviewSectionTitle = (props: overviewSectionTitlePropsType) => {
  return (
    <Typography className={props.styles}>                 {/* variant={props.variant} */}
      {props.titleName}
    </Typography>
  )
}
